namespace ui
{
	export namespace Form
	{

		export class ColorInput
			extends Input
		{

			public constructor( value: string, descriptor: IBasicInputDescriptor )
			{
				super( value, descriptor, 'color', InputValueTypes.STRING );
			}

			public value( val: string | null ): ColorInput
			{
				return super.value( val );
			}

			public val(): string|null
			{
				return ( this.m_Root.val() as string ).toString() || null;
			}

		}

	}
}
